import axios from 'axios';
import qs from 'qs';

export const getSchoolCodes = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: Record<string, any>;
}) => axios.get(`/api/v1/school-codes/${schoolId}?${qs.stringify(params)}`);

export const generateSchoolCodes = (data: any) =>
  axios.post('/api/v1/school-codes/generate', data);

export const exportSchoolCodes = (schoolId: string, data: any) =>
  axios.post(`/api/v1/school-codes/${schoolId}/export`, data, {
    responseType: 'blob',
  });

export const exportActivatedStudentsReport = (
  schoolId: string,
  data: { from?: string; to?: string; schoolPrefix?: string },
) =>
  axios.post(`/api/v1/school-codes/${schoolId}/activated-students/export`, data, {
    responseType: 'blob',
  });

export const getSchoolCodePrefixes = (schoolId: string) =>
  axios.get(`/api/v1/school-codes/${schoolId}/prefixes`);

export const getSchoolCodeActivationStats = ({
  schoolId,
}: {
  schoolId: string;
}) => axios.get(`/api/v1/school-codes/${schoolId}/activation-stats`);
